import { api } from "./client";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const getProductExpiryReport = async (params = {}) => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-expiry-report/list`,
      {
        params,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get Product Expiry Report API Error:", error);
    throw error.response?.data || { message: "Failed to fetch product expiry report" };
  }
};

export const getProductExpiryReportFilters = async () => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-expiry-report/filters`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Get Product Expiry Report Filters API Error:", error);
    throw error.response?.data || { message: "Failed to fetch filter data" };
  }
};

export const exportProductExpiryReportExcel = async (params = {}) => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-expiry-report/export/excel`,
      {
        params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Export Product Expiry Report Excel API Error:", error);
    throw error.response?.data || { message: "Failed to export excel file" };
  }
};

export const exportProductExpiryReportPdf = async (params = {}) => {
  try {
    const lang = localStorage.getItem("lang") || "en";

    const response = await api.get(
      `${API_BASE_URL}api/product-expiry-report/export/pdf`,
      {
        params,
        responseType: "blob",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Accept-Language": lang,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Export Product Expiry Report PDF API Error:", error);
    throw error.response?.data || { message: "Failed to export pdf file" };
  }
};